// extracted by css-extract-rspack-plugin
export default {"CardFrame":"BoardCardFrame-module__CardFrame__IJw4l","DraggedCard":"BoardCardFrame-module__DraggedCard__HkmmO"};